import { iconBaseProps, type FillableIconProps } from "@/components/ui/icons/icon-base"

export const BagIcon = ({ size = 22, filled = false, ...props }: FillableIconProps) =>
  filled ? (
    <svg {...iconBaseProps(size, props)} fill="currentColor">
      <path d="M15.4 8V6a3.4 3.4 0 0 0-6.8 0v2H3.6l-1 12.2A2.6 2.6 0 0 0 5.2 23h13.6a2.6 2.6 0 0 0 2.6-2.8L20.4 8h-5Zm-5.2-2a1.8 1.8 0 0 1 3.6 0v2h-3.6V6Z" />
    </svg>
  ) : (
    <svg {...iconBaseProps(size, props)} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4.6 8h14.8v11.4a2.4 2.4 0 0 1-2.4 2.4H7a2.4 2.4 0 0 1-2.4-2.4z" />
      <path d="M8.3 8V6.3a3.7 3.7 0 0 1 7.4 0V8" />
    </svg>
  )
